import React from "react";
import Footer from "../../../components/Footer";
import Navbar from "../../../components/Navbar";
import ArticleHeading from "../Components/Article Heading";
import s from "./AngloAmericanIct.module.css";

function AngloAmericanIct() {
  const backText = "Go back to notice board";

  return (
    <>
      <Navbar />
      <ArticleHeading btnText={backText} />

      <div className={s.container}>
        <h4 className={s.heading}>
          Anglo American ICT Education ICT Champion Learnership
        </h4>
        <span className={s.date}>Uploaded on 25th Oct, 2021</span>

        <div className={s.content}>
          <p>
            We are in the 4IR and there are several changes that are happening
            in Industry. Besides the internal impact and considerations, these
            changes are going to have an impact on the communities we operate
            in, specifically on Education and the ability to obtain
            jobs/employment. The labour market demands much higher levels of
            agility than ever before. Successful entrants into the labour market
            must have the ability to continuously reskill themselves and they
            must be comfortable transacting with and manipulating technology to
            suit their needs. The nature of jobs is also changing towards
            higher-skilled jobs despite automation. And therefore, Education
            needs to produce school leavers that are equipped for this new
            environment. Most importantly, school leavers need to be agile, able
            to be re-skilled continuously, have an entrepreneurial spirit and
            able to adapt to new technologies seamlessly.
          </p>

          <p>&nbsp;</p>

          <p>
            The role of technology in education continues to evolve as
            innovations emerge and schools increasingly introduce ICT as part of
            teaching and learning strategies. The potential benefits of
            information technology in education include:
          </p>

          <p>
            <br />
            •&nbsp;&nbsp; &nbsp;Providing more creative learning experiences
            <br />
            •&nbsp;&nbsp; &nbsp;Improving behaviour
            <br />
            •&nbsp;&nbsp; &nbsp;Improving engagement and knowledge of IT
            <br />
            •&nbsp;&nbsp; &nbsp;Improving attendance
            <br />
            •&nbsp;&nbsp; &nbsp;Boosting results
            <br />
            •&nbsp;&nbsp; &nbsp;Reducing the attainment gap
          </p>

          <p>
            <br />
            Anglo American, through its AASA Education Programme, has embarked
            on an initiative to br/ing digital and ICT skills to its communities
            through their schools and students. Anglo American, in partnership
            with The Impact Catalyst, are ensuring adequate connectivity at all
            schools, with free wifi, by end 2021. Anglo American will also be
            providing all supported schools (109) with devices that will assist
            students and teachers in adopting ICT learning and development into
            the classroom; providing students and teachers with an
            education-based platform for all zero-rated education content; and
            run various sprints to help build ICT skills amongst the youth.
          </p>

          <p>&nbsp;</p>

          <p>
            To support the ICT adoption into our schools, we are aiming to
            develop ICT Champions who can support us on the ground and drive
            usage and adoption in the schools, and with the teachers and
            students. Anglo American is therefore kicking off an ICT Champion
            Learnership.&nbsp;
          </p>

          <p>&nbsp;</p>

          <p>
            The learnership will run across a 12-month period (Febr/uary –
            January). Leaners will be selected from the outgoing matric class in
            the AASA Schools, through the career guidance intervention. Leaners
            will be asked to apply and selected through key criteria. Those with
            high potential and a passion for IT will be considered for the
            learnership. The learnership will include both formal and on-the-job
            training. Learners will also be expected to manage an ICT champion
            role across a few schools to help Anglo American drive ICT adoption
            and skills.&nbsp;
          </p>

          <p>
            <br />
            <strong>ICT CHAMPION ROLES AND RESPONSIBILITIES&nbsp;</strong>
            <p>&nbsp;</p>
          </p>

          <p>
            Becoming an ICT champion provides a fast-track route to success for
            youth who want to make a difference to the lives of their learners,
            improve the awareness of ICT in schools and local communities, all
            while boosting their own careers. Through this tole, you will gain
            ICT related work experience whilst helping to modernise the teaching
            and learning environments in our local community schools. It offers
            the opportunity to develop numerous skills that will be vital when
            seeking to further your studies or find employment.&nbsp;
          </p>

          <p>
            <br />
            As an ICT Champion, you will be able to influence how technology is
            used in a school. This is crucial because, while schools in South
            Africa are moving towards digitalisation, it can be tempting to
            focus on the latest new development rather than those things that
            will make a needed difference to teachers and learners.
          </p>

          <p>
            <br />
            The ICT Champion will support Anglo American by:assisting to get
            devices setup, adopted and used in schools; support both teachers to
            focus on the benefits of technology when it comes to achieving
            educational goals; and help learners embr/ace technology and build
            their ICT skills.&nbsp;
          </p>

          <p>
            <br />
            The following <strong>characteristics </strong>are commonly
            demonstrated by Champions and developed during their time as a
            Champion:&nbsp;
          </p>

          <p>&nbsp;</p>

          <p>
            •&nbsp;&nbsp; &nbsp;<strong>Passionate </strong>about supporting and
            promoting ICT in the AASA Schools and local communities
            <br />
            •&nbsp;&nbsp; &nbsp;<strong>Approachable </strong>at all levels
            within the schools from Management, teachers to learners and
            parents&nbsp;
            <br />
            •&nbsp;&nbsp; &nbsp;<strong>Organized </strong>in handling multiple
            tasks with an interest in developing project management skills
            <br />
            •&nbsp;&nbsp; &nbsp;<strong>Respected </strong>as a team player and
            aware of how to conduct themselves in the school environment&nbsp;
            <br />
            •&nbsp;&nbsp; &nbsp;<strong>Influential </strong>in promoting ICT in
            schools as part of teaching and learning in the AASA schools
            <br />
            •&nbsp;&nbsp; &nbsp;<strong>Interested </strong>in developing ICT
            skills and becoming the ICT expert and go-to person
          </p>

          <p>
            ICT Champions will receive <strong>full support </strong>
            through their 12-month learnership, namely:
            <br />
            •&nbsp;&nbsp; &nbsp;Certified ICT technical training – ICT
            fundamentals
            <br />
            •&nbsp;&nbsp; &nbsp;Additional ICT training to increase
            employability options e.g. digital marketing, graphic design etc.
            <br />
            •&nbsp;&nbsp; &nbsp;Additional training focused on non-ICT skills
            e.g. managing finances, presenting and facilitating etc.&nbsp;
            <br />
            •&nbsp;&nbsp; &nbsp;12-month job and experience in ICT role
            <br />
            •&nbsp;&nbsp; &nbsp;Monthly stipend from Anglo American
            <br />
            •&nbsp;&nbsp; &nbsp;Device - laptop
            <br />
            •&nbsp;&nbsp; &nbsp;Anglo American employee mentor – support on
            coaching and development
          </p>
          <p>&nbsp;</p>

          <p>
            <strong>EXPECTATIONS OF AN ICT CHAMPION&nbsp;</strong>
          </p>
          <br />

          <p>
            <strong>Time Commitment&nbsp;</strong>
            <br />
            <br />
            The IT Champions will be required to be at their designated AASA
            schools during the School Term to support the teachers and learners
            with IT devices, teaching and learning content and IT
            troubleshooting. The hours are generally able to be completed at
            times with minimal impact to business needs and priorities.
          </p>

          <p>
            <br />
            The IT Champions will be asked to set up after school and holiday IT
            clubs and activities for the learners in consultation with the
            School management and AASA. &nbsp;
          </p>

          <p>
            <br />
            1-Year Commitment: The IT Champion’s terms are for one year within
            the AASA school with the possibility of being linked to the AASA
            learner leadership programme.&nbsp;
          </p>

          <p>&nbsp;</p>

          <p>
            <strong>Responsibilities&nbsp;</strong>
          </p>

          <p>
            1. <strong>ICT Device adoption: </strong>ICT Champions will work
            with JET and our selected device provider to help manage the device
            adoption, usage and any technical support at schools to teachers and
            students.&nbsp;
          </p>

          <p>
            <br />
            2. <strong>Participate in Champion Trainings and Meetings: </strong>
            AASA will provide a variety of resources and support. Champions can
            expect monthly interactions with the AASA ICT Coordinator in the
            form of phone meetings, in-person meetings and training (either at
            the School or other offsite locations and remote). Meetings and
            trainings are required for Champions for their own personal
            development but also to support the ICT programme in the AASA
            Schools. A variety of efforts are made to make these opportunities
            as accessible to all Champions as possible.&nbsp;
          </p>

          <p>
            <br />
            3. <strong>Walk the Talk: </strong>The ICT Champions are expected to
            organize ICT teaching and learning opportunities for school
            management, teachers and learners.&nbsp;
          </p>

          <p>
            <br />
            4. <strong>Communicate and Promote:</strong> The ICT Champions
            spread the word about the ICT programmes and any other initiatives
            (ICT Sprint competitions, after school clubs etc) and invite
            participation. They post flyers, send emails, talk with the Schools
            management, teachers and learners to share information about the ICT
            programme, new initiatives and future events. The ICT Champions
            serve as a primary point of contact between the AASA ICT
            Coordinator, AASA Service Providers and the School management,
            teachers and District officials on matters related to the ICT
            programme and other ICT related activities in the AASA
            Schools.&nbsp;
          </p>

          <p>
            <br />
            5. <strong>Celebr/ate and Recognize Participation: </strong>
            The ICT Champions encourage the School management, teachers and
            learners to develop their skills, knowledge and understanding of how
            to use IT in the classroom to enhance the teaching and learning in
            the School. They recognize and praise participation in
            programs.&nbsp;
          </p>

          <p>
            <br />
            6. <strong>Report Back: </strong>The IT Champions will be asked to
            provide information in reports using a standard template on a
            variety of areas, for example: Progress of the ICT programme in the
            AASA School, ICT Sprint Competitions, After School clubs, new
            initiatives and surveys undertaken to gather information from the
            teachers and learners. This feedback is essential for AASA to being
            able to support the IT Champion but also to identify areas that need
            attention or consideration.
          </p>

          <p>&nbsp;</p>

          <p>
            If you are interested in applying for the 2022 ICT Learnership,
            please discuss with your TEN/L&amp;T coach to assist in submitting
            an application to Anglo American.&nbsp;
          </p>

          <p>&nbsp;</p>

          <p>
            <strong>
              All applications for the learnership will be done online.
              Applications will open on 15 October with a due date for
              submissions on 30 October 2021.&nbsp;
            </strong>
          </p>

          <p>&nbsp;</p>

          <p>
            <strong>
              For more information, please contact you L&amp;T/TEN Coach on the
              details below or email&nbsp;&nbsp;
            </strong>
            <u>AAEducation@angloamerican.com</u>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AngloAmericanIct;
